// extracted by mini-css-extract-plugin
export var backupIcon = "_n0-1";
export var image = "_n0-0";